module.exports = __webpack_public_path__ + "static/audience-hero-732da596c1fc86674fde5885bbd02a6a.png";